import { Chip, Text, Group } from "@mantine/core";
import _ from "lodash";
import { useTranslation } from "react-i18next";

const Chips = ({
  form,
  name,
  label,
  defaultValue,
  multiple = false,
  items,
  disabled = false,
}) => {
  const currentValue = _.get(form.values, name) ?? defaultValue;
  const { t } = useTranslation();

  const handleChange = (v) => {
    if (disabled) return;
    form.setFieldValue(name, v);
  };

  const selectedItems =
    items?.filter((item) =>
      multiple
        ? (currentValue || []).includes(item.value)
        : item.value === currentValue
    ) ?? [];

  if (disabled) {
    return (
      <>
        {label && (
          <Text size="md" pb={"xs"}>
            {label}
          </Text>
        )}
        {selectedItems.length > 0 && (
          <Group spacing="xs">
            {selectedItems.map((item) => (
              <Chip key={item.value} checked variant="filled">
                {t(item.label)}
              </Chip>
            ))}
          </Group>
        )}
      </>
    );
  }

  return (
    <>
      {label && (
        <Text size="md" pb={"xs"}>
          {label}
        </Text>
      )}
      <Chip.Group
        value={currentValue}
        onChange={handleChange}
        multiple={multiple}
      >
        {items?.length > 0 &&
          items.map((item) => (
            <Chip key={item.value} value={item.value}>
              {t(item.label)}
            </Chip>
          ))}
      </Chip.Group>
    </>
  );
};

export default Chips;
